const en = {
    locale: 'en',
    messages: {
        'history.welcome': 'Welcome !',
        'history.message': 'Hi there {name}, how are you doin ?',
        'error.message': 'Lost'
    }
}

export { en }
